// extracted by mini-css-extract-plugin
export default {"Popover":"Popover_Popover__OSMEt","PopoverContainer":"Popover_PopoverContainer__GRVhv"};